// This is just an example,
// so you can safely delete all default props below

export default {
    shopping_cart: 'My Travel Selections',
    trip: 'Tur',
    group_discount: 'Group Discount',
    discount: 'discount',
    total: 'Total',
    vat: 'VAT',
    outward_trip: 'Outward Trip',
    backward_trip: 'Backward Trip',
    norwegian_krone: 'NOK'
}
